import { render, staticRenderFns } from "./sso-error.page.vue?vue&type=template&id=2852a0f2&"
import script from "./sso-error.page.vue?vue&type=script&lang=ts&"
export * from "./sso-error.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports